/* Vault */
/*

    tabType: 2,//一级Tab 1入库 2在库 3出库
    subTabType: 2001,//二级tab 
                在库：201未上架 202竞拍 203一口价 204出库 205售出
                出库：300全部 301待支付 302待寄出 303已寄出 304待提货 405已完成 406已取消

*/
import { getInfo, getTime, GetWorldUSD, priceExchange, setUTC, countDown } from "@/api/public";
import commonEventJs from "@/common/CommonEventJs.js";

const userInfo = getInfo() || {};

const kefu = 'kefu';
const walletLink = 'walletLink';
const uploadedLink = 'uploadedLink';


import VaultEntrustSale from '@/components/vault/entrust-sale.vue';
import VaultDetail from '@/components/dialog/vaultDetail';
import ListPagination from "@/components/listpagination";

import NotNull from "@/components/notnull.vue";
export default {
    components: {
        VaultEntrustSale, VaultDetail, NotNull, ListPagination
    },
    data() {
        return {
            userInfo: getInfo(),
            token: getInfo().ChineseToken, // 用户token
            MemberId: getInfo().MappingUserId, // 用户ID 
            UserId:getInfo().Id,  // 海外ID用户ID
            MemberMobile: getInfo().TelPhone,
            MemberRealName: getInfo().NickName,

            walletLink: walletLink,
            uploadedLink: uploadedLink,
            kefu: kefu,
            loading: false,
            tabType: 2,//一级Tab 1入库 2在库 3出库
            vaultType: -1,//0：在库未上架，1：在库竞拍 2：在库一口价，3 出库 ，4 售出
            subTabType: 2001,//二级tab 

            isExpress: false,// 物流信息弹框 
            Status: 4, //1查询未上架的商品(status=0||status=1)    2查询代卖中的商品(委托中的)   Status=4  未委托卡片
            SortType: 2, //排序 1=截标时间从晚到早，2=截标时间从早到晚，3=价格（高-低），4=价格（低-高）默认按照上架时间从早到晚排序
            PickupStatus: '',//出库状态集合    待支付  = 1, 	待寄出 = 2, 	已寄出 = 3, 	待提货 = 4, 	已完成 = 5, 	已取消 = 6,
            PickupType: '',//提货类型 寄回 = 0, 门店自提 = 1,
            byWay: 2, //买卡方式   1一口价、2竞拍
            listType: 1, // 已上架=1，下架=3
            Title: '',//商品名称
            vaultTitle: '',// 识别码
            PageIndex: 1,//页码
            PageSize: 60,// 每页条数
            pageTotal: 0,//总条数
            isCount: false, // 判断列表有没有值
            valutList: null, // valut仓列表
            codeScore: {},// valut仓商品评级表格
            imgUrl: '',// valut仓商品大图链接
            effectiveDay: '',// 商品有效期 1,3,5,7
            startPrice: 1,// vault起拍价
            storeList: '',// 门店列表
            checkList: [],// 已选择提货商品列表
            pickupLoading: false,//提货提交中
            addressList: '',//用户收货地址列表
            userAddress: '',//用户收货地址
            noMore: false,
            noButton: true,
            orderId: '',
            orderDetail: '',
            expressDetail: '',// 快递详情
            isWallet: 0,//是否开通钱包 未开通 0，开通 1，商家升级 2，审核中 3，升级失败 4，银行卡失败 5
            IsAgree: false,//
            errorMsg: '',
            url: "https://ykf-webchat.7moor.com/wapchat.html?accessId=4b31f970-0558-11ec-8bed-0d4cbeb252bd&clientId=" + kefu + "&language=ZHCN",
            stockFrom: {  //提货表单
                MemberId: getInfo().MappingUserId,
                PickupType: 0,
                ProvinceName: '',
                ReceiverName: '',
                receiverPhone: '',
                receiverAddress: '',
                ConsigneeName: '',
                ConsigneePhone: '',
                Remark: '',
            },
            rules: {
                ConsigneeName: [{ required: true, message: '请输入提货人姓名', trigger: 'blur' }],
                ConsigneePhone: [{ required: true, message: '请输入提货人电话', trigger: 'blur' },
                { pattern: /^[1][3-9]\d{9}$/, message: '请确认提货人电话', trigger: 'blur' }]
            },
            AgreementFormData: {
                UserId: "",
                ServiceAgreementId: "",
                ServiceAgreementType: "",
                AreaId: "",
                VersionNo: "",
                Device: 'web',
                DeviceVersion: 'web',
            },
            pickeroptions: {
                disabledDate: (time) => {
                    const date = new Date();
                    date.setDate(date.getDate() + 30);//有效期30天
                    let maxDate = new Date(date.toISOString().split('T')[0]);
                    return time.getTime() > maxDate.getTime() || time.getTime() <= new Date().getTime() - 86400000
                }
            },
            //委托代卖
            sellingList: [],//已委托的代卖卖家，代卖筛选列表
            SellerUserId: null,//代卖人id
            entrustSaleShow: false,
            // commodityDetail: '',// valut仓商品详情
            cardDetail: {},// card商品详情
            itemDetail: {},//vault商品详情
            dislogType: this.$enumInfo.dislogType,
            urlParams: this.$route.query,//url参数
            SellCommodityType: 21,//已售出订单类型
            vaultWareId: '',

            nowData: setUTC(new Date().getTime(), -8),
        }
    },
    watch: {
        vaultType: {
            handler(fd) {
                const that = this;
                that.valutList = []
                that.PageIndex = 1;
                that.isCount = false
               // console.log(fd, 'vaultType')
                if (fd == 0 || fd == 5) {
                    that.Status = 4;
                    if (fd == 5) {
                        that.Status = 2;
                    }
                    that.getData('GetCommodityByMemberId')
                    return
                }
                if (fd == 1) {
                    that.byWay = 2;
                    that.SortType = 2;
                    that.getData('SearchCommodities')
                    return
                }
                if (fd == 4) {
                    //http://worldapi.cardhobby.cn/ValutApi/SearchVaultSellCommodity
                    that.getData('SearchVaultSellCommodity')
                    return
                }
            },
            deep: true
        },
        SortType: {
            handler(fd) {
                //console.log(fd, 'SortType')
                const that = this;
                that.PageIndex = 1;
                that.valutList = []
                that.getData('SearchCommodities')
            },
            deep: true
        },
        SellCommodityType: {
            handler(fd) {
                //console.log(fd, 'SellCommodityType')
                const that = this;
                that.PageIndex = 1;
                that.valutList = [];
                that.SellCommodityType = fd;
                that.getData('SearchVaultSellCommodity');
            },
            deep: true
        },
    },
    created: function () {
        GetWorldUSD()
        var that = this;
        if (that.$route.params.id) {
            that.vaultWareId = that.$route.params.id
        }
        that.AccountId = getInfo().AccountId;

        if (that.$route.query.vaultType != null && that.$route.query.vaultType != undefined) {
            that.vaultType = parseInt(that.$route.query.vaultType)
        } else {
            
            if(that.vaultType<0){
                that.vaultType = 0
            }else{
                that.getData('GetCommodityByMemberId')
            }
        }
        that.getData('GetWalletInfo')

        that.GetSellingList()

    },
    mounted: function () {
        var that = this;
        that.cardTimer()
    },
    computed: {
        ApplyStatusEnum() {
            return {
                0: this.$t('vault.AwaitingConsignment'),
                1: this.$t('vault.ApplicationPending'),
                2: this.$t('vault.Accepted'),//委托中
            }
        },
        StatusEnum() {
            return {
                0: this.$t('vault.Processing'),//待入库
                1: this.$t('vault.TagInVault'),
                2: this.$t('vault.WithdrawalInProgress'),
                3: this.$t('vault.Withdrawn'),
                4: this.$t('vault.ListingInProgress'),
                5: this.$t('vault.Sold')
            }
        },
        ThousandAndDecimal() {
            return function (num) {
                //金额千分位
                return commonEventJs.thousandAndDecimal(num);
            }
        },
        subputon() {
            return function () {
                var that = this;
                var val = true
                if (that.checkList.length > 0) {
                    var val = false
                }
                if (that.stockFrom.PickupType == 1) {
                    var val = true
                    if (that.stockFrom.ConsigneeName && that.stockFrom.ConsigneePhone) {
                        var val = false
                    }
                }
                that.noButton = val
                return val
            }
        },
        SetStatusEnumVal() {
            var that = this;
            return function (item, type) {
                var seachType = that.Status;//1查询未上架的商品(status=0||status=1)    2查询代卖中的商品(委托中的)   Status=4  未委托卡片
                /*
                    item.ApplyStatus 委托的状态 0待委托   1申请中   2委托中 
                    item.Status 待入库=0,  寄存中 = 1,  提货中 = 2,  已提货 = 3,  上架中 = 4,已售出 = 5
                */
                //console.log("seachType", seachType, type)
                var ApplyStatusEnum = that.ApplyStatusEnum;
                var StatusEnum = that.StatusEnum;
                var data = {};
                if (type == 'inStock') {
                    /* type: inStock 在库  */
                    data = {
                        show: true,
                        // 委托中的 区分是否上架、出售
                        //label: seachType == 4 ? (item.Status == 0 ? StatusEnum[item.Status] : ApplyStatusEnum[item.ApplyStatus]) : (item.Status == 1 ? ApplyStatusEnum[item.ApplyStatus] : StatusEnum[item.Status]),
                        //key: seachType == 4 ? (item.Status == 0 ? 1 : (item.Status == 1 ? 2 : 0)) : (item.Status == 1 ? item.ApplyStatus : item.Status)

                        // 委托中的 不区分上架、出售状态
                        label: seachType == 4 ? (item.Status == 0 ? StatusEnum[item.Status] : ApplyStatusEnum[item.ApplyStatus]) : ApplyStatusEnum[item.ApplyStatus],
                        key: seachType == 4 ? (item.Status == 0 ? 1 : (item.Status == 1 ? 2 : 0)) : item.ApplyStatus
                    };
                }
                return data
            }
        },
        cardOwnPrice() {
            const that = this;
            return function (item) {
                var price = commonEventJs.numMulti(Number(item.USD_TotalPrice), Number(item.CardOwnerRate))
                return price ? 'USD ' + price.toLocaleString(2) : '-'
            }
        },
        priceExchange() {
            return function (val) {
                return priceExchange(val, "USD")
            }
        },
        ApplicationPending() {
            return function (val, nowData) {
                let itemEnd = val.toString().replace(/-/g, "/")
                itemEnd = setUTC(itemEnd, -8, 'cn')
                itemEnd = countDown(itemEnd, nowData)
                return itemEnd
            }
        }

    },
    methods: {

        cardTimer() {
            setTimeout(() => {


                var nowTime = new Date().getTime()
                this.nowData = setUTC(nowTime, -8)
                this.cardTimer()
            }, 1000)
        },
        setTime(val) {
            return getTime(val, -8, '', 'cn')
        },
        /*数据请求*/
        getData(api, data = '', key) {
            var that = this;
            var fun = "", method = "GET";
            switch (api) {
                case 'SearchVaultSellCommodity':

                    that.loading = true;
                    //memberid=19078&pageSize=20&pageIndex=1&SellCommodityType=21&Title=&token=
                    var parm = {
                        MemberId: that.userInfo.MappingUserId, //19125
                        token: that.userInfo.ChineseToken, //'4809e7e6f828f7c99092c5af95e78dfe'
                        operator_id: that.userInfo.MappingUserId,//19125
                        Title: '',
                        PageIndex: that.PageIndex,
                        PageSize: that.PageSize,
                        SellCommodityType: that.SellCommodityType
                    }
                    fun = function (res) {
                        if (res.result > 0) {
                            if (res.count <= 0) {

                                that.isCount = true
                            }
                            that.pageTotal = res.count
                            that.valutList = res.data
                        }

                        that.loading = false;
                    }
                    that.$get(that.$interface[api], parm).then(res => {
                        fun(res)
                    })
                    break;
                case 'GetCommodityByMemberId':
                    /* 在库未上架列表 */
                    that.loading = true;
                    that.tabType = 2
                    fun = function (res) {
                        //that.vaultType = 0
                        //console.log('GetCommodityByMemberId',res)
                        if (res.Result > 0) {
                            that.isCount = false
                            that.pageTotal = res.Count
                            if (res.Count > 0) {
                                if (data == 'stacking') {
                                    if (res.Data.length > 0) {
                                        that.valutList = [...that.valutList, ...res.Data];
                                    } else {
                                        that.noMore = true;
                                    }
                                } else {
                                    that.noMore = false;
                                    that.valutList = res.Data;
                                    that.stockFrom.ValutId = res.Data[0].ValutId
                                }
                            } else {
                                that.isCount = true
                            }
                        } else {
                            that.isCount = true

                        }
                        that.loading = false;
                    }
                    var parm = {
                        MemberId: that.userInfo.MappingUserId,
                        Status: that.Status,
                        Title: that.Title,
                        SellerUserId: that.SellerUserId,
                        PageIndex: that.PageIndex,
                        PageSize: that.PageSize,
                        SortBy: null,//当前价格=1   截标时间=2    不传或者传null 为默认排序
                        SortType: 1//正序=1  倒序=-1 不传或者传null 为默认排序
                    }
                    if (that.vaultWareId) {
                        parm.VaultId = that.vaultWareId
                    }

                    that.$get(that.$interface[api], parm).then(res => {
                        fun(res)
                    })
                    break;
                case 'SearchCommodities':
                    /* 在库已上架列表 */
                    that.loading = true;
                    fun = function (res) {
                        //console.log('SearchCommodities', res)
                        //that.vaultType = 1
                        if (res.result > 0) {
                            that.isCount = false

                            that.pageTotal = res.count
                            if (res.count > 0) {
                                that.noMore = false;
                                that.valutList = res.data;
                            } else {
                                that.isCount = true
                            }
                        } else {
                            that.isCount = true

                        }
                        that.loading = false;
                    }

                    //   byWay: 2,//2=拍卖,1=一口价
                    //   sortType: 1,//1=最快结束时间，2=价格（高-低），3=价格（低-高），4=最新发布，5出价次数（高-低）
                    //   listType: 1,//1=已上架，2=即将上架，3=已下架
                    var parm = {
                        MemberId: that.userInfo.MappingUserId,
                        operator_id: that.userInfo.MappingUserId,
                        SearchKey: that.Title,
                        PageIndex: that.PageIndex,
                        PageSize: that.PageSize,
                        byWay: that.byWay,
                        SortType: that.SortType,
                        listType: 1,
                        VaultId: that.vaultWareId,
                        token: that.token
                    }
                    that.$get(that.$interface['SearchCommodities'], parm).then(res => {
                        fun(res)
                    })
                    break
                case 'GetCommodityById':
                    /* valut商品详情 */
                    that.loading = true;
                    that.commodityDetail = {};
                    that.cardDetail = {};
                    fun = function (res) {
                        //console.log('GetCommodityById-res', res)
                        if (res.Result > 0 && res.Data) {
                            let _data = res.Data
                            that.imgUrl = _data.TitImg
                            var tPrice = _data.Price || _data.EstimatePrice
                            _data.maxPrice = commonEventJs.numMulti(tPrice, _data.MaxPriceRatio)

                            if (_data.maxPrice <= 1) {
                                _data.maxPrice = 1
                            } else {
                                _data.maxPrice = Math.ceil(_data.maxPrice)
                            }
                            /* 评级表格 */
                            //that.getBabyData(_data)//关
                            that.GetDetailCommodity(_data);
                        } else {
                            that.$message.error("获取商品详情失败");
                        }
                        that.loading = false;
                    }
                    //console.log("GetCommodityById", api, parm)
                    that.$get(that.$interface[api], data).then(res => {
                        fun(res)
                    });
                    break
                case 'GetNewCommodityByCodeScore':
                    /* 评级表格 */
                    that.loading = true;
                    fun = function (res) {
                        if (res.Result > 0) {
                            that.codeScore = res.Data;
                        }
                        that.loading = false;
                    }
                    var parm = data
                    that.$get(that.$interface['GetNewCommodityByCodeScore'], parm).then(res => {
                        fun(res)
                    });
                    break
                case 'GetStoreListByPageApp':
                    /* 获取门店列表 */
                    // fun = function (res) {
                    //     if (res.Result > 0) {
                    //         let _data = res.Data
                    //         /* 剔除海外门店与港澳台门店 */
                    //         let verifyCode = '香港,台湾,澳门'
                    //         that.storeList = _data.filter(item => item.Province == '中国' && (verifyCode.indexOf(item.City) < 0))
                    //         that.setAddress(that.storeList[0])
                    //         try {
                    //             $.cookie('storeList', 0, { expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000), path: "/" });
                    //             window.localStorage.setItem('storeList', JSON.stringify(that.storeList));
                    //         } catch (e) { }
                    //     }
                    // }
                    // var parm = { PageIndex: 1, PageSize: 999, StoreType: "0" }
                    // that.$post(that.$interface[api], parm).then(res => {
                    //     fun(res)
                    // });
                    break
                case 'PickupApplyAdd'://提货申请
                    that.noButton = true
                    that.pickupLoading = true;
                    fun = function (res) {
                        //console.log('PickupApplyAdd-res', res);
                        if (res.Result > 0) {
                            that.$message('提货成功');
                            window.location.href = '/order/OutboundDetail/' + res.Data
                        } else {
                            that.$message.error(res.Msg);
                            that.noButton = false
                            that.pickupLoading = false;
                        }
                    }
                    var parm = data
                    that.$post(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break
                case 'GetPickupApplyByPage': //出库列表
                    fun = function (res) {
                        that.vaultType = 3
                        that.tabType = 3
                        if (res.Result > 0) {
                            that.isCount = false
                            if (res.Count > 0) {
                                that.pageTotal = res.Count
                                that.noMore = false;
                                res.Data.map(item => {
                                    item.isMore = false;
                                    try {
                                        if (item.CardCommodities && item.CardCommodities.length > 2) {
                                            item.isMore = true;
                                        }
                                    } catch (e) { }
                                })
                                that.valutList = res.Data;
                            } else {
                                that.isCount = true
                            }
                        } else {
                            that.isCount = true

                        }
                        that.loading = false;
                    }
                    var parm = {
                        memberId: that.userInfo.MappingUserId,
                        PickupStatus: that.PickupStatus ? [that.PickupStatus] : [],
                        PickupType: that.PickupType,
                        PageIndex: that.PageIndex,
                        PageSize: that.PageSize
                    }
                    that.$get(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break
                case 'GetPickupApplyById': //出库详情
                    fun = function (res) {
                        if (res.Result > 0) {
                            that.orderDetail = res.Data
                            if (res.Data && res.Data.Code) {
                                var pram = "&customField={ \"OrderNo\":\"" + res.Data.Code + "\",\"Phone\":\"" + that.MemberMobile + "\",\"NickName\":\"" + that.MemberRealName + "\",\"问题来源\":\"卡淘Vault\"}&otherParams ={\"peerId\":\"10068483\", \"NickName\":\"" + that.MemberRealName + "\"}&urlTitle = 卡淘Vault"
                                that.url = that.url + pram
                            }
                        } else {
                            that.isCount = true

                        }
                        that.loading = false;
                    }
                    var parm = {
                        Id: that.orderId,
                    }
                    that.$post(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break

                case 'GetExpressSubscribeInfo'://提货申请查询物流
                    fun = function (res) {
                        if (res.Result > 0) {
                            that.isExpress = true;
                            that.expressDetail = res.Data[0].Tracklist
                        }
                    }
                    var parm = data
                    that.$post(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break
                case 'getAddresList'://获取收货地址
                    fun = function (res) {
                        if (res.Result > 0) {
                            that.addressList = res.Data
                            that.setAddress(res.Data[0])
                        }
                    }
                    that.$get(that.$interface['getAddressList'], '').then(res => {
                        fun(res)
                    });
                    break
                case 'GetWalletInfo'://获取钱包信息
                    that.entrustSaleBtnShow = true;
                    try {
                        const urlParams = that.urlParams;
                        const pageFrom = urlParams.f || '';
                        if (pageFrom == 'panel') {
                            const UserAccount = that.checkUserAccount();
                            if (!UserAccount) return;//如果没有钱包信息，直接返回
                            that.entrustSaleShow = true;
                            that.$nextTick(() => {
                                const child = that.$refs.VaultEntrustSale;
                                if (child) {
                                    child.entrustSaleDialog();
                                }
                            });
                        }
                    } catch (err) {
                        console.log('GetWalletInfo-catch', err)
                    }
                    break;
                //case 'GetVaultSoldLog':
                //    that.vaultType = 4
                //    that.loading = true;
                //    fun = function (res) {
                //        if (res.Result > 0) {
                //            that.valutList = res.Data;
                //        }
                //        that.loading = false;
                //    }
                //    var parm = {
                //        id: that.userInfo.MappingUserId,
                //        status:'21',
                //        pageindex: that.pageindex
                //    }
                //    commonEventJs.Request(api, parm, fun, 'POST');
                //    break;
                case 'GetNewDocment'://获取协议内容
                    //提货说明 type = 22

                    that.loading = true;
                    fun = function (res) {
                        //console.log("GetNewDocment", res);
                        if (res.Result) {
                            var _data = res.Data;
                            that.IsAgree = _data.IsAgree
                            that.AgreementFormData.UserId = that.userInfo.MappingUserId
                            that.AgreementFormData.ServiceAgreementId = _data.ID
                            that.AgreementFormData.ServiceAgreementType = _data.ServiceAgreementType
                            that.AgreementFormData.AreaId = _data.AreaId
                            that.AgreementFormData.VersionNo = _data.VersionNo
                        }
                        that.loading = false;
                    }
                    var parm = `?ServiceAgreementType=21&memberId=${that.userInfo.MappingUserId}`
                    that.$get(that.$interface['GetNewServiceAgreements'], parm).then(res => {
                        fun(res)
                    });
                    break;
                case 'SetServiceAgreementLog':
                    that.loading = true;
                    fun = function (res) {
                        if (res.result == 1) {
                            that.IsAgree = true
                        }
                        that.loading = false;
                    }
                    var parm = that.AgreementFormData
                    that.$post(that.$interface[api], parm).then(res => {
                        fun(res)
                    });
                    break;
                default:
                    break;
            }
        },
        GetDetailCommodity(data) {
            let that = this;
            //console.log("GetDetailCommodity", data);
            if (data.CardId) {
                const parm = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'CommodityID': data.CardId, 'lag': 'en' }

                const fun = function (res) {
                    //console.log("GetDetailCommodity-res", res);
                    if (res.result == 1) {
                        //关注数... 浏览量...
                        that.cardDetail = res.data;
                        //that.commodityDetail = {...res.Data }
                    } else { }

                    that.itemDetail = data
                    that.dislogType.vaultDetails = true
                }
                that.$get(that.$interface['DetailCommodity'], parm).then(res => {
                    fun(res)
                });
            } else {
                that.cardDetail = {};
                that.itemDetail = data
                that.dislogType.vaultDetails = true
            }

        },
        getExpress() {
            let that = this
            var _data = {
                OrderId: that.orderDetail._id,
                ShipperCode: that.orderDetail.LogisticsCompanyCode, //公司编号
                LogisticCode: that.orderDetail.TrackingNumber //公司编号
            }
            that.getData('GetExpressSubscribeInfo', _data)
        },
        /* 评级框架 */
        getBabyData(obj) {
            let that = this
            let _data = obj.StarCardSku
            //console.log(_data,'_data',that.$interface['GetNewCommodityByCodeScore'])
            //let data = `?id=${obj.ValutId}`
            if (_data) {
                try {
                    if (_data.CertificationNumber && _data.ProfessionalGrader) {
                        var _code = _data.CertificationNumber.replace(/[^a-zA-Z0-9]/g, "");///去所有特殊符号: /[^a-zA-Z0-9]/g    只保留数字: /\D/g   只去#: /#/g
                        let data = {
                            code: _code,
                            companyCode: _data.ProfessionalGrader,
                            category: 'dee8e93d-bf0d-46d7-a817-45db58756940'
                        }
                        // `?code=${_code}&companyCode=${_data.ProfessionalGrader}&category=dee8e93d-bf0d-46d7-a817-45db58756940`
                        that.getData('GetNewCommodityByCodeScore', data)
                    }
                } catch (e) {
                }
            }
        },
        /* 获取门店列表 缓存有就拿缓存，没有就调接口 cookie存一天 */
        // getStoreList() {
        //     let that = this
        //     let isCookie = $.cookie('storeList')
        //     if (isCookie) {
        //         let _data = window.localStorage.getItem('storeList')
        //         try {
        //             _data = JSON.parse(_data)
        //             that.storeList = _data
        //             that.setAddress(_data[0])

        //         } catch (e) {
        //             that.getData('GetStoreListByPageApp');
        //         }
        //     } else {
        //         that.getData('GetStoreListByPageApp');
        //     }
        // },
        getPickup() {
            let that = this
            let _data = {
                memberId: that.userInfo.MappingUserId,
                PageIndex: that.PageIndex,
                PageSize: that.PageSize
            }
            that.getData('GetPickupApplyByPage', _data)
        },
        /* 获取valut仓商品详情 */
        getDetail(obj, val) {
            let that = this
            // console.log('getDetail',obj, val,that.vaultType, [0, 5].includes(that.vaultType))
            let _data = {
                Id: [0, 5].includes(that.vaultType) ? obj.Id : obj.ValutCommodityId
            }
            if (val) {
                _data = { Id: obj._id }
            }
            // console.log(_data, '_data')
            that.getData('GetCommodityById', _data)
        },
        getValut(val) {
            let that = this
            that.PageIndex = 1
            that.noMore = false;
            if ([0, 5].includes(val)) {
                that.getData('GetCommodityByMemberId');
            }
            if ([1, 2].includes(val)) {
                that.getData('SearchCommodities');
            }
            //if (val == 4) {
            //    that.getData('GetVaultSoldLog');
            //}

        },
        infiniteValutList() {
            let that = this
            //console.log('infiniteValutList', that.noMore, that.vaultType)
            if (!that.noMore) {
                that.PageIndex += 1;
                that.SortBy = ''; // 当前价格=1   截标时间=2    不传或者传null 为默认排序
                that.SortType = -1; //正序=1  倒序=-1 不传或者传null 为默认排序
                if (that.vaultType == 0) {
                    that.getData('GetCommodityByMemberId', 'stacking');
                }
                //else if (that.vaultType == 1) {
                //    that.getData('SearchCommodities', 'stacking');
                //}
            }
        },
        checkListVal(e) {
            let that = this
            //console.log('checkListVal', e, that.checkList)
        },
        /* 设置用户地址 */
        setAddress(obj) {
            let that = this
            if (that.stockFrom.PickupType == 0) {
                /* 用户收货地址 */
                that.userAddress = obj
                that.stockFrom.ReceiverName = obj.Consignee
                that.stockFrom.receiverPhone = obj.Mobile
                that.stockFrom.ProvinceName = obj.Provice
                that.stockFrom.receiverAddress = obj.Address
            }
            if (that.stockFrom.PickupType == 1) {
                that.userAddress = obj
                that.stockFrom.ReceiverName = obj.StoreName
                that.stockFrom.receiverPhone = obj.StorePhone
                that.stockFrom.ProvinceName = obj.City
                that.stockFrom.receiverAddress = obj.City + (obj.District || '') + obj.Address
                that.stockFrom.StoreId = obj._id
            }
        },
        GetPickupStatus(val) {
            //出库状态集合    待支付  = 1, 	待寄出 = 2, 	已寄出 = 3, 	待提货 = 4, 	已完成 = 5, 	已取消 = 6,
            let text = ''
            switch (val) {
                case 1:
                    text = '待支付';
                    break
                case 2:
                    text = '待寄出';
                    break
                case 3:
                    text = '已寄出';
                    break
                case 4:
                    text = '待提货';
                    break
                case 5:
                    text = '已完成';
                    break
                case 6:
                    text = '已取消';
                    break
                default:
                    break;

            }
            return text
        },
        /* 切换图片 */
        viewImg(item) {
            this.imgUrl = item.ImageUrl
        },
        /* 切换提货渠道  个人或门店 */
        // viewOutBoundTab(val) {
        //     var that = this;
        //     that.stockFrom.PickupType = val
        //     that.stockFrom.ConsigneeName = ''
        //     that.stockFrom.ConsigneePhone = ''
        //     if (val == 0) {
        //         that.getData('getAddresList');
        //     }
        //     if (val == 1) {
        //         that.getStoreList();
        //     }
        // },
        pickupApplyAdd() {
            var that = this;
            var _data = that.stockFrom;
            _data.CardIds = that.checkList
            //console.log('pickupApplyAdd_data', _data,)
            //console.log('pickupApplyAdd_checkList', that.checkList)
            if (that.pickupLoading) return
            if (that.stockFrom.PickupType == 1) {
                //手机号验证
                that.$refs['stockFrom'].validate((valid) => {
                    if (valid) {
                        that.getData('PickupApplyAdd', _data);
                    } else {
                        return ''
                    }

                })
            } else {
                that.getData('PickupApplyAdd', _data);
            }
            //
        },
        setMessageBox() {
            var that = this;
            var html = `<ul>
                <li class='on'>1、开通卡淘电子账户</li>
                <li>2、阅读并同意<a href="/Market/Article?serviceAgreementType=21" target="_blank">《卡淘Vault寄存卡牌代卖协议》</a></li>
            </ul>`
            var confirmText = that.isWallet == 1 ? '同意' : '去开通'
            that.$confirm(html, '商品上架前，请完成以下步骤', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: confirmText,
                cancelButtonText: '取消',
            }).then(() => {

                if (that.isWallet != 1) {
                    //是否开通钱包 未开通 0，开通 1，商家升级 2，审核中 3，升级失败 4，银行卡失败 5
                    switch (that.isWallet) {
                        case 0:
                            if (that.errorMsg) {
                                that.$message.error(that.errorMsg);
                            }
                            setTimeout(function () {
                                window.location.href = that.walletLink
                            }, 1000)
                            break
                        case 2:
                            that.$message.error('商家升级');
                            break
                        case 3:
                            that.$message.error('审核中');
                            break
                        case 4:
                            that.$message.error('企业升级失败');
                            setTimeout(function () {
                                window.location.href = that.uploadedLink
                            }, 1000)
                            break
                        case 5:
                            that.$message.error('银行卡更换失败');
                            setTimeout(function () {
                                window.location.href = that.walletLink + '&changebank=1'
                            }, 1000)
                            break
                        default:
                            that.$message.error('未开通');
                            break;

                    }
                } else {
                    //阅读并同意 xxx条约 
                    that.IsAgree = true
                    that.getData('SetServiceAgreementLog');
                }
            })
        },



        /* 分页*/

        getCurrent(val) {
            var that = this;
            if ([0, 5].includes(that.vaultType)) {
                that.getData('GetCommodityByMemberId')
            }
            if ([1, 2].includes(that.vaultType)) {
                that.SortType = val
                that.getData('SearchCommodities')
            }
            if (that.vaultType == 3) {
                that.PickupStatus = val
                that.getData('GetPickupApplyByPage')
            }
        },
        currentChange(val) {
            var that = this;
            that.PageIndex = val;
            that.getCurrent()
            //that.getData('WalletRecordByPage');
            //console.log(`当前页: ${val}`);
        },
        sizeChange(val) {
            var that = this;
            that.PageIndex = 1;
            that.PageSize = val;
            that.getCurrent()
            //that.getData('WalletRecordByPage');
            //console.log(`每页 ${val} 条`);
        },

        GetSellingList() {
            //我已委托的代卖商品，代卖筛选列表
            const that = this;
            if (that.sellingList.length) return;
            const fun = function (res) {
                //console.log("GetSellingList",res)
                if (res.Result == 1) {
                    that.sellingList = res.Data || [];
                }
            }
            var parm = { pageIndex: 1, pageSize: 999, MemberId: that.userInfo.MappingUserId }
            that.$get(that.$interface['GetSellingList'], parm).then(res => {
                fun(res)
            });
        },
        checkUserAccount() {
            const that = this;
            const accountId = that.userInfo.AccountId || '';
            if (!accountId || accountId.indexOf('acct') < 0) {
                // **** 未开通卡淘电子账户 *****************************************************************
                var htm = `<div>${this.$t('alert.StripeAccount')}</div>`
                that.$confirm(htm, that.$t('base.hint'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: that.$t('base.GetStarted'),
                    cancelButtonText: that.$t('base.cancel'),
                }).then(() => {
                    // 前往开通跳转页面
                    that.$router.push({
                        path: '/terms/becomeseller'
                    })
                    // window.open(that.walletLink, "_blank");
                }).catch(() => { });
                return false;
            } else {
                return true;
            }
        },
        //调用子组件
        SetVaultEntrustSale(type = 'Multi') {
            const that = this;
            const UserAccount = that.checkUserAccount()
            if (!UserAccount) return;//如果没有钱包信息，直接返回
            that.entrustSaleShow = true;
            that.$nextTick(() => {
                const child = that.$refs.VaultEntrustSale;
                if (child) {
                    if (type == 'Single') child.SingleCardApply();
                    if (type == 'Multi') child.MultiCardApply();
                }
            });
        },
        //商品委托代码子组件回调
        handleCardOperation(item = {}, type = '') {
            //商品详情（子组件）调用委托代码（子组件）
            //type:entrust 单卡委托->SingleCardApply() cancel撤销->UpdateApplyStatus()
            this.entrustSaleShow = true;
            this.$nextTick(() => {
                const child = this.$refs.VaultEntrustSale;
                if (child) {
                    if (type == 'entrust') {
                        child.SingleCardApply(item);
                    }
                    if (type == 'cancel') {
                        child.UpdateApplyStatus(item);
                    }
                }
            });
        },
        handleRefreshCommodity(obj = {}) {
            this.entrustSaleShow = false;
            //console.log('handleRefreshCommodity.obj', obj)
            this.valutList = [];
            this.getData('GetCommodityByMemberId');
            this.GetSellingList()
            if (obj._id) {
                this.dislogType.vaultDetails = false;
                this.getData('GetCommodityById', { Id: obj._id })
            }
        }

    },
    destroyed: function () {
        var that = this;
    }
}


// WEBPACK FOOTER //
// ./src/pages/Vault/js/vue-Vault.js